{"regionLabel":"Suggestion de langue","message":"Cette page est aussi disponible en français.","cta":"Voir en français","dismiss":"Fermer"}